import { Avatar, Badge, Box, Typography } from "@mui/material";
import { stringAvatar, stringToColor } from "../user/avatarUtils";

interface BadgedAvatarAvatarProps {
    title: string;
    avatar?: string;
    subtitle?: string;
    subavatar?: string;
    size?: string;
    subsize?: string;
    fontSize?: string;
    subfontSize?: string;
    marginRight?: number;
}

const BadgedAvatar = (props: BadgedAvatarAvatarProps) => {
    const size = props.size || "55px";
    const subsize = props.subsize || "50px";
    if(props.subavatar) {
        return <Box sx={{ mr: props.marginRight == undefined ? 2 : props.marginRight }}>
            <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                <Avatar sx={{ backgroundColor: stringToColor(`${props.subtitle}`), height: subsize, width: subsize }} 
                        alt={`${props.subtitle}`} src={`${props.subavatar}`}>
                    <Typography variant="h6" component="span" sx={{ fontSize: props.subfontSize }}>
                        {stringAvatar(`${props.subtitle}`)}
                    </Typography>
                </Avatar>
                }>
                <Avatar sx={{ backgroundColor: stringToColor(props.title), height: size, width: size }} 
                        alt={`${props.title}`} src={`${props.avatar}`}>
                    <Typography variant="h6" component="span" sx={{ fontSize: props.fontSize }}>
                        {stringAvatar(props.title)}
                    </Typography>
                </Avatar>
            </Badge>
        </Box>;
    }

    return <Box sx={{ mr: props.marginRight == undefined ? 2 : props.marginRight }}>
        <Avatar sx={{ backgroundColor: stringToColor(props.title), height: size, width: size }}
                alt={`${props.title}`} src={`${props.avatar}`}>
            <Typography variant="h6" component="span" sx={{ fontSize: props.fontSize }}>
            {stringAvatar(props.title)}
            </Typography>
        </Avatar>
    </Box>;
};

export default BadgedAvatar;